/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseTrianglesHClosedIcon24Solid = forwardRef('ArrowCollapseTrianglesHClosedIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "m4.987 4.488 4.861 4.86a3.75 3.75 0 0 1 0 5.304l-4.86 4.86C3.884 20.616 2 19.835 2 18.276V5.725c0-1.56 1.885-2.34 2.987-1.237Z" }),
        React.createElement("path", { d: "m19.013 4.488-4.861 4.86a3.75 3.75 0 0 0 0 5.304l4.86 4.86c1.103 1.103 2.988.322 2.988-1.237V5.725c0-1.56-1.885-2.34-2.987-1.237Z" })));
});
